import React, { useState } from "react";

const ReturnPolicy = () => {
    const [showProductDetails, setShowProductDetails] = useState(false);

    // Function to handle the click on the terms and conditions link
    const handleClick = () => {
      // Show product details when Terms and Conditions are clicked
      setShowProductDetails(true);
  
      // Set a timer to hide the product details after 5 seconds (for example)
      setTimeout(() => {
        setShowProductDetails(false);
      }, 50000); // 5000ms = 5 seconds
    };
  
    return (
      <div>
        {/* Terms and Conditions anchor */}
        <a href="#terms" onClick={handleClick}>
        Return and Refund Policy
        </a>
  
        {/* Product Details section */}
        {showProductDetails && (
          <div className="product-details">
            <h2>Return and Refund Policy</h2>
            
            <p>We want you to be completely satisfied with your purchase. If you are not satisfied with your electronic product, you may request a return within 7 to 10 working days days of delivery, provided the item is unused, in its original packaging, and includes all accessories and documentation. Returns must be approved in advance—please contact our support team to initiate the process. Refunds will be issued to the original payment method after we inspect and verify the condition of the returned item. Please note that shipping fees are non-refundable, and certain items such as software, downloadable content, or opened headphones may not be eligible for return. Defective or damaged products may qualify for exchange or a full refund.</p>
          </div>
        )}
      </div>
    );
  
};

export default ReturnPolicy;